export default function parseBoolFromParam(param) {
  if (['true', 1, true].includes(param)) {
    return true;
  }
  return false;
}